import React from 'react'
import { PieChart, Pie, Legend, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { colors } from '../../Utils/constants';
import { convertSecsToTime } from '../../Helpers/helpers';

const DynamicPiechart = (props) => {

    let { data, text = null, dataKey, width, height } = props

    const toolTipStyles = {
        backgroundColor: 'white',
        padding: '10px 10px',
        borderRadius: '10px',
        boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
        width: 'fit-content',
    }

    const CustomTooltip = ({ active, payload, label }) => {
        return (
            <div style={toolTipStyles}>
                {payload?.map((data) => (
                <h4
                    key={0}
                    style={{
                    color: data.name === 'Availability Downtime' ? '#EB5757' :
                    data.name === 'Planned Downtime' ? '#1EA849' :
                    data.name === 'Rejections' ? '#EB5757' : '#1E6EFE',
                    }}
                >

                {data.name === 'Good Output' && 'Rejections' ? (

                `${data.name}: ${data.value}`
                ) : (
                `${data.name}: ${convertSecsToTime(data.value)}`
                )}

                </h4>
                ))}

            </div>
        )
    };

    return (
        <PieChart width={width} height={height}>
            <Pie
                dataKey={dataKey}
                data={data}
                innerRadius={40}
                outerRadius={80}
                fill={"black"}
            >
                {data?.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                ))}

            </Pie>
            {text && text}
            <Tooltip content={CustomTooltip} />
        </PieChart>
    )
}

export default DynamicPiechart